export type AppPreferencesModuleType = {
    /** Sets a value for the given key in iOS UserDefaults database. */
    set(key: string, value: string, group?: string): void
}
